<template>
    <section class="courses-block cursor-pointer" id="courses_block">
        <div class="container">
            <div class="d-none d-lg-block">
                <div class="fz-16 cursor-pointer w-100" data-bs-toggle="collapse" data-bs-target="#collapseCoursesD" aria-expanded="false" aria-controls="collapseCoursesD">
                    <span class="d-flex justify-content-end fw-300">Обновлено: {{ moment(BTC2USDT_upd).format("DD-MM-YYYY HH:mm") || 'сегодня'}}</span>
                    <div class="green_bg rounded-pill mx-auto align-items-center px-3 py-2 w-100">
                        <div class="d-flex align-items-center gap-2 gap-sm-5 mob-curses">
                            <span>1 USDT = {{ format(USDT2RUB) }} RUB</span>
                            <span>1 USDT = {{ format(USDT2EUR) }} EUR</span>
                            <span>1 BTC = {{ format(BTC2USDT) }} USDT</span>
                            <div class="text-center ms-auto" style="width: fit-content;">
                                <span class="text-black cursor-pointer bg-acidgreen rounded-pill px-3 py-1 d-block"><img src="/img/shevron.svg" class="me-1 arrow"> Все курсы</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block d-lg-none">
                <div class="courses-toggle w-100 mb-auto" data-bs-toggle="collapse" data-bs-target="#collapseCoursesL" aria-expanded="false" aria-controls="collapseCoursesL">
                    <div class="green_bg rounded-pill mx-auto align-items-center px-3 py-2 w-100">
                            <div class="d-flex align-items-center justify-content-center gap-2 gap-sm-4 mob-curses">
                                <span>1 USDT = {{ format(USDT2RUB) }} RUB</span>
                                <span>1 USDT = {{ format(USDT2EUR) }} EUR</span>
                                <span>1 BTC = {{ format(BTC2USDT) }} USDT</span>
                            </div>
                    </div>
                    <div class="text-center mx-auto" style="width: fit-content;">
                        <span class="text-black cursor-pointer bg-acidgreen rounded-pill px-3 py-1 d-block" style="margin-top:-3px;">Все курсы <img src="/img/shevron.svg" class="ms-1 arrow"></span>
                    </div>
                </div>
            </div>

            <div class="d-none d-lg-block">
                <div class="w-100 collapse" id="collapseCoursesD">
                    <div class="courses-expanded courses-expanded-bg-img rounded rounded-4 mt-2 p-4 mx-auto w-100">
                        <div class="row">
                            <div class="col mb-4 mb-lg-0" style="max-width:fit-content">
                                <div class="d-flex flex-column gap-3">
                                    <div class="currency-pair" v-for="pair in fiatPairs" :key="pair.label">
                                        <div class="d-flex gap-3 text-nowrap">
                                            <span class="pair-title fz-16">USDT</span>
                                            <span class="text-success"> <img src="/static/img/courses/buy.svg"> {{ format(pair.buy) }} {{ pair.label }}</span>
                                            <span class="text-danger ms-2 d-flex gap-1 align-items-center"> <img src="/static/img/courses/sell.svg"> {{ format(pair.sell) }} {{ pair.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-3">
                                <div class="d-flex flex-column gap-3">
                                    <div class="crypto-rate border-0" v-for="crypto in cryptoPairs" :key="crypto.label">
                                        <span class="fz-16 d-flex align-items-center gap-2">1 {{ crypto.label}} <img src="/static/img/ico/ico-history-convert-2.svg" width="44" height="8"> {{ format(crypto.value) }} USDT</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block d-lg-none">
                <div class="w-100 collapse" id="collapseCoursesL">
                    <div class="courses-expanded rounded rounded-4 mt-2 p-4 mx-auto">
                        <div class="row">
                            <div class="col mb-4 mb-md-0" style="max-width:fit-content">
                                <div class="d-flex flex-column gap-3">
                                    <div class="currency-pair" v-for="pair in fiatPairs" :key="pair.label">
                                        <div class="d-flex gap-3 text-nowrap">
                                            <span class="pair-title fz-16">USDT</span>
                                                <span class="text-success"> <img src="/static/img/courses/buy.svg"> {{ format(pair.buy) }} {{ pair.label }}</span>
                                                <span class="text-danger ms-2 d-flex gap-1 align-items-center"> <img src="/static/img/courses/sell.svg"> {{ format(pair.sell) }} {{ pair.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="d-flex flex-column gap-3">
                                    <div class="crypto-rate border-0" v-for="crypto in cryptoPairs" :key="crypto.label">
                                        <span class="fz-16 d-flex align-items-center gap-2">1 {{ crypto.label}} <img src="/static/img/ico/ico-history-convert-2.svg" width="44" height="8"> {{ format(crypto.value) }} USDT</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
import moment from "moment";
export default {
    props: ['courses'],
    filters: {
        format: val => `${val}`.replace(/(\d)(?=(\d{4})+([^\d]|$))/g,'$1 '),
    },
    data() {
        return {
            moment: moment,
        }
    },
    methods: {
        getCourse(pair) {
            let course = this.courses?.find(item => item.pair == pair);
            return (course?.rate / course?.parser?.currency_to?.delimiter) || 0;
        },
        format(val) {
            return new Intl.NumberFormat('ru-RU').format(parseFloat(val).toFixed(2));
        },
    },
    computed: {

        BTC2USDT() {
            return this.getCourse(`BTC-USDT`);
        },
        //Покупка
        USDT2KZT() {
            return this.getCourse(`USDT-KZT`);

        },
        BTC2RUB() {
            return this.getCourse(`BTC-RUB`);
        },
        BTC2KZT() {
            return this.getCourse(`BTC-KZT`);
        },
        BTC2UZS() {
            return this.getCourse(`BTC-UZS`);
        },
        USDT2UZS() {
            return this.getCourse(`USDT-UZS`);
        },
        USDT2RUB() {
            return this.getCourse(`USDT-RUB`);
        },

        USDT2EUR() {
            return this.getCourse(`USDT-EUR`);
        },

        BNB2USDT() {
            return this.getCourse(`BNB-USDT`);
        },

        ETH2USDT() {
            return this.getCourse(`ETH-USDT`);
        },

        LTC2USDT() {
            return this.getCourse(`LTC-USDT`);
        },

        TON2USDT() {
            return this.getCourse(`TON-USDT`);
        },

        //Продажа
        RUB2USDT() {
            return this.getCourse(`RUB-USDT`);
        },

        RUB2BTC() {
            return this.getCourse(`RUB-BTC`);
        },

        KZT2BTC() {
            return this.getCourse(`KZT-BTC`);
        },

        UZS2BTC() {
            return this.getCourse(`UZS-BTC`);
        },

        KZT2USDT() {
            return this.getCourse(`KZT-USDT`);
        },

        UZS2USDT() {
            return this.getCourse(`UZS-USDT`);
        },

        EUR2USDT() {
            return this.getCourse(`EUR-USDT`);
        },

        BTC2USDT_upd() {
            return this.courses?.find(item => item.pair == `BTC-USDT`)?.updated_at;
        },
        fiatPairs() {
            return [
                { label: 'RUB', buy: this.USDT2RUB, sell: this.RUB2USDT },
                { label: 'KZT', buy: this.USDT2KZT, sell: this.KZT2USDT },
                { label: 'UZS', buy: this.USDT2UZS, sell: this.UZS2USDT },
                { label: 'EUR', buy: this.USDT2EUR, sell: this.EUR2USDT },
            ];
        },
        cryptoPairs() {
            return [
                { label: 'ETH', value: this.ETH2USDT },
                { label: 'BNB', value: this.BNB2USDT },
                { label: 'LTC', value: this.LTC2USDT },
                { label: 'TON', value: this.TON2USDT },
            ];
        },
    },
}
</script>

<style scoped>

.arrow {
    transition: transform 0.3s;
  }
  [aria-expanded="true"] .arrow {
    transform: rotate(180deg);
  }

.w-40 {
    width: 50px;
}

.fz-14 {
    font-size: 14px;
}
.fz-16 {
    font-size: 16px;
}
.green_border {
    border: 1px solid #35634F;
    border-radius: 5;
}
.fw-300 {
    font-weight: 300;
}
.green_bg {
    background-color: #35634F;
}
.brs-5 {
    border-radius: 5px;
 }
.courses-block {
    position: relative;
    z-index: 99;
}

.courses-toggle {
    cursor: pointer;
    font-size: 10px;
  }
  .courses-updated {
    color: rgba(255, 255, 255, 0.7);
  }
  .currency-pair:not(:last-child), .crypto-rate {
    border-bottom: 1px solid #7D8983;
    font-size: 14px;
  }
  .currency-pair .text-success {
    min-width: 100px;
  }
  .pair-header {
    color: #fff;
    font-size: 16px;
  }
  .rates {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .text-success {
    color: #74ED79 !important;
  }
  .text-danger {
    color: #FF6D6D !important;
  }
  .courses-expanded {
    width: fit-content;
    background: rgba(53, 99, 79, 0.40);
    backdrop-filter: blur(23px);
    padding: 18px 28px;
    overflow-x: hidden;
  }

  .courses-expanded-bg-img {
    background-image: url('/public/img/monetki.png');
    background-size: auto;
    background-position: calc(100% + 100px) calc(100% + 210px);
    background-repeat: no-repeat;
  }

  @media (max-width: 1400px) {
    .courses-expanded-bg-img {
        background-position: calc(100% + 300px) calc(100% + 210px);
    }
  }

  @media (max-width: 1200px) {
    .courses-expanded-bg-img {
        background-position: calc(100% + 450px) calc(100% + 210px);
    }
  }

.btn-primary {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    gap: 5px;
    background: #4AA485;
    min-width: 268px;
    margin-left: auto;
    outline: 0;
    border: 0;
}

.btn-primary span{
    display: block;
}
.btn-primary:hover {
    background: #4AA485;
}

.btn-primary[aria-expanded = "true"] .arrow {
    transform: rotate(180deg);
}
.courses_title {
    display: flex;
    align-items: center;
    gap: 10px;
}

.text-success {
    color: #74ED79 !important;
}

.text-danger {
    color: #FF6D6D !important;
}

.courses_line {
    font-size: 16px;
}

@media(max-width:992px) {
    .btn-primary {
        width: 100%;    
    }
    .courses_wrap {
        padding-top: 8px;
        padding-bottom: 8px;
    }
}

@media(max-width:768px) {
    .courses_wrap {
        gap: 0;
    }
    .courses_wrap_item .fz-16{
        font-size: 12px !important;
    }
}

@media(max-width:576px) {
    .courses_wrap_item .fz-16{
        font-size: 11px !important;
    }
    .mob-curses {
      font-size: 9px;
    }
}

@media(max-width: 425px) {
    .mob-curses {
        justify-content: space-between !important;
      }
}

@media(max-width: 375px) {
    .courses_line {
        font-size: 12px;
        font-weight: 300;
    }
    .mob-curses {
      font-size: 8px;
    }
    .courses_wrap_item .fz-16 {
      font-size: 9px !important;
    }
}

@media(max-width: 320px) {
    .mob-curses {
        font-size: 8px;
      }
}

</style>
